import { IGetFuncionarioNomesUseCase } from "../../../presentation/useCases/read/get_funcionario_nomes_use_case";
import { FuncionarioNomeDropDown } from "../../models/funcionario_nome_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioNomesUseCase
 */

export class GetFuncionarioNomesUseCase implements IGetFuncionarioNomesUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFuncionarioNomesDropDown(): Promise<FuncionarioNomeDropDown[]> {
    return await this.repository.getFuncionarioNomesDropDown();
  }
}
